import Contest_1 from 'assets/images/content/contest/m-1.svg';
import Contest1 from 'assets/images/content/contest/contest_1.svg';
import Contest_2 from 'assets/images/content/contest/m-2.svg';
import Contest2 from 'assets/images/content/contest/contest_2.svg';
import Contest_3 from 'assets/images/content/contest/m-3.svg';
import Contest3 from 'assets/images/content/contest/contest_3.svg';
import Contest_4 from 'assets/images/content/contest/m-4.svg';
import Contest4 from 'assets/images/content/contest/contest_4.svg';
import Contest_5 from 'assets/images/content/contest/m-5.svg';
import Contest5 from 'assets/images/content/contest/contest_5.svg';
import Contest_6 from 'assets/images/content/contest/m-6.svg';
import Contest6 from 'assets/images/content/contest/contest_6.svg';

export const Contest = () => {
    return (
        <section className='contest'>
            <div className='container contest__container'>
                <div className='contest__wrap'>
                    <div className='contest__block'>
                        <h2 className='contest__title title'>Цели конкурса</h2>
                        <div className='contest__d-flex'>
                            <div className='contest__item'>
                                <div className='contest__icon'>
                                    <picture>
                                        <source media='(max-width: 768px)' srcSet={Contest_1} />
                                        <img src={Contest1} alt='' />
                                    </picture>
                                </div>

                                <div className='contest__text text-s18'>
                                    Повышение качества управления многоквартирными домами, удовлетворенности потребителей жилищными услугами
                                </div>
                            </div>
                            <div className='contest__item'>
                                <div className='contest__icon'>
                                    <picture>
                                        <source media='(max-width: 768px)' srcSet={Contest_2} />
                                        <img src={Contest2} alt='' />
                                    </picture>
                                </div>

                                <div className='contest__text text-s18'>
                                    Повышение эффективности работы управляющих организаций
                                </div>
                            </div>
                            <div className='contest__item'>
                                <div className='contest__icon'>
                                    <picture>
                                        <source media='(max-width: 768px)' srcSet={Contest_3} />
                                        <img src={Contest3} alt='' />
                                    </picture>
                                </div>

                                <div className='contest__text text-s18'>
                                    Повышение активности и ответственности собственников жилых помещений в процессе содержания общего имущества многоквартирных домов
                                </div>
                            </div>
                            <div className='contest__item'>
                                <div className='contest__icon'>
                                    <picture>
                                        <source media='(max-width: 768px)' srcSet={Contest_4} />
                                        <img src={Contest4} alt='' />
                                    </picture>
                                </div>

                                <div className='contest__text text-s18'>
                                    Повышение активности граждан в принятии решений и реализации проектов по формированию комфортной городской среды
                                </div>
                            </div>
                            <div className='contest__item'>
                                <div className='contest__icon'>
                                    <picture>
                                        <source media='(max-width: 768px)' srcSet={Contest_5} />
                                        <img src={Contest5} alt='' />
                                    </picture>
                                </div>

                                <div className='contest__text text-s18'>
                                    Повышение информированности граждан об их правах, обязанностях и возможностях в сфере управления многоквартирными домами
                                </div>
                            </div>
                            <div className='contest__item'>
                                <div className='contest__icon'>
                                    <picture>
                                        <source media='(max-width: 768px)' srcSet={Contest_6} />
                                        <img src={Contest6} alt='' />
                                    </picture>
                                </div>

                                <div className='contest__text text-s18'>
                                    Повышение информированности граждан по вопросам энергосбережения и энергетической эффективности многоквартирного дома (домов)
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='contest__block'>
                        <h2 className='contest__title title'>Задачи</h2>
                        <div className='contest__d-flex'>
                            <div className='contest__item'>
                                <div className='contest__text text-s18'>
                                    Выявить и обнародовать наиболее интересную и актуальную практику по управлению многоквартирными домами
                                </div>
                            </div>
                            <div className='contest__item'>
                                <div className='contest__text text-s18'>
                                    Выявить и обнародовать лучшую практику самоорганизации граждан для реализации программ по благоустройству и формированию комфортной городской среды
                                </div>
                            </div>
                            <div className='contest__item'>
                                <div className='contest__text text-s18'>
                                    Выявить и обнародовать лучшую практику по организации взаимодействия органов местного самоуправления, субъектов бизнеса и граждан в решении задач формирования комфортной городской среды, повышения качества управления и технических характеристик многоквартирных домов
                                </div>
                            </div>
                            <div className='contest__item'>
                                <div className='contest__text text-s18'>
                                    Выявить и обнародовать лучшую практику повышения энергоэффективности многоквартирных домов
                                </div>
                            </div>
                            <div className='contest__item'>
                                <div className='contest__text text-s18'>
                                    Привлечь внимание СМИ к качественным изменениям в области управления жилой недвижимостью, стимулировать всестороннее и объективное освещение этих изменений
                                </div>
                            </div>
                            <div className='contest__item'>
                                <div className='contest__text text-s18'>
                                    Поощрить качественно работающие управляющие организации и объединения собственников
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
